import styled, { keyframes } from 'styled-components/macro'
import { Overlay } from 'styles/misc'

const animation = keyframes`
  from { transform: rotateZ(0); }
  to   { transform: rotateZ(360deg); }
`

const circleAnimation = keyframes`
  from { stroke-dashoffset: 175.94; }
  to   { stroke-dashoffset: 0; }
`

export const Container = styled.div`
  ${Overlay}
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: var(--background-color);

  svg {
    width: 4rem;
    animation: 2s ${animation} linear infinite;
  }

  circle {
    animation: 4s ${circleAnimation} linear infinite;
  }
`
